// FinancePro design tokens shared across redesigned screens.
// Centralizing colors / shadows / radii keeps every page on the same visual language
// without touching feature logic.

export const FP = {
  color: {
    navy: "#0E1F33",
    navyDeep: "#0A1828",
    navySoft: "#16314F",
    navyMuted: "#1F3D5F",

    surface: "#F4F6FB",
    surfaceAlt: "#EEF2F8",
    cardBg: "#FFFFFF",
    border: "#E6EAF1",
    borderStrong: "#D7DEE9",

    textPrimary: "#0F172A",
    textSecondary: "#5A6B85",
    textMuted: "#94A3B8",

    accentBlue: "#1B6CFB",
    accentBlueSoft: "#E6EFFF",

    success: "#10B981",
    successDark: "#047857",
    successSoft: "#DCFCE7",

    warning: "#F59E0B",
    warningSoft: "#FEF3C7",

    danger: "#E11D48",
    dangerSoft: "#FFE4E6",

    info: "#0EA5E9",
    infoSoft: "#E0F2FE",
  },
  shadow: {
    soft: "0 1px 2px rgba(15,23,42,0.04), 0 8px 22px rgba(15,23,42,0.06)",
    md: "0 4px 12px rgba(15,23,42,0.08), 0 16px 40px rgba(15,23,42,0.10)",
    navy: "0 8px 24px rgba(14,31,51,0.18), 0 24px 60px rgba(14,31,51,0.20)",
  },
  radius: {
    sm: 8,
    md: 12,
    lg: 16,
    xl: 20,
  },
};

export default FP;
